import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { CheckCircle2 } from 'lucide-react';

export const RoleCard = ({ role, icon: Icon }) => {
  return (
    <Card className="border-slate-200 dark:border-slate-800 bg-gradient-to-br from-white to-slate-50 dark:from-slate-900 dark:to-slate-800 shadow-xl">
      <CardContent className="p-8 sm:p-12">
        {/* Role Header */}
        <div className="flex items-start space-x-6 mb-8 pb-8 border-b border-slate-200 dark:border-slate-700">
          <div className="bg-gradient-to-br from-emerald-500 to-teal-600 w-16 h-16 rounded-2xl flex items-center justify-center shadow-lg flex-shrink-0">
            <Icon className="h-8 w-8 text-white" />
          </div>
          <div className="flex-1">
            <div className="flex items-center space-x-3 mb-3">
              <h3 className="text-3xl font-bold text-slate-900 dark:text-white">
                {role.title}
              </h3>
              <Badge className="bg-emerald-100 text-emerald-700 dark:bg-emerald-900 dark:text-emerald-300 border-0">
                {role.features.length} Fitur
              </Badge>
            </div>
            <p className="text-lg text-slate-600 dark:text-slate-400 leading-relaxed">
              {role.description}
            </p>
          </div>
        </div>

        {/* Features List */}
        <div className="space-y-6">
          <h4 className="text-xl font-bold text-slate-900 dark:text-white mb-6 flex items-center">
            <span className="bg-gradient-to-r from-emerald-600 to-teal-600 w-1 h-6 rounded-full mr-3"></span>
            Fitur & Fungsi
          </h4>
          <div className="grid gap-6">
            {role.features.map((feature, index) => (
              <div
                key={index}
                className="group bg-white dark:bg-slate-900 rounded-xl p-6 border border-slate-200 dark:border-slate-800 hover:border-emerald-500 dark:hover:border-emerald-500 transition-all duration-300 hover:shadow-lg hover:-translate-y-1"
              >
                <div className="flex items-start space-x-4">
                  <div className="bg-emerald-100 dark:bg-emerald-900/30 w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                    <CheckCircle2 className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
                  </div>
                  <div className="flex-1">
                    <h5 className="text-lg font-bold text-slate-900 dark:text-white mb-2">
                      {feature.name}
                    </h5>
                    <p className="text-slate-600 dark:text-slate-400 leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default RoleCard;